// ************************************ //
// Every page - framework functionality //
// ************************************ //

import $ from 'jquery';
import 'Vue/vue-router';

// These modules are always used
import { NavLoad } from 'App/nav/load';
import { Social as SocialShare } from 'App/social/share';
import { Cookie } from 'App/cookie/cookie';
import { BackToTop } from 'App/back-to-top/back-to-top';
import { expandCollapse } from 'App/expand-collapse/expand-collapse';
import { selectLink } from 'App/select-link/select-link';

// Publish resize and scroll events for other modules to use
import { publish } from 'Util/pubsub';
import { throttle } from 'Util/throttle';

// These modules are used often enough, or are small enough, that it's worth always loading them
import { Rte } from 'Controls/control.rte';
Rte.init();

NavLoad.init();
SocialShare.init();
Cookie.init();
BackToTop.init();

const $window = $(window);
$window.on('resize', throttle(() => publish('/window/resize'), 250));
$window.on('scroll', () => publish('/window/scroll'));

// ALL swiper instances
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade, Scrollbar } from 'swiper/modules';

// Plugin stylesheet
import 'swiper/swiper-bundle.min.css';
//import '@vuepic/vue-datepicker/dist/main.css';
import "vue-datepicker-next/index.css";


if ($('.swiper').length) {
	let $swiper = $('.swiper');
	const swiperInstances = [];

	// Register the Navigation module
	Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Scrollbar]);

	for (let i = 0; i < $swiper.length; i++) {
		let opts = $swiper.eq(i).data('swiper');
		let swiper = new Swiper($swiper.eq(i)[0], opts);

		if ($swiper.eq(i).hasClass('swiper--mobile-only')) {
			swiperInstances.push({ swiper, $container: $swiper.eq(i) });
			toggleMobileSwiper(swiper, $swiper.eq(i));
		}

		var SwiperInstance = $swiper.eq(i).data('swiper-instance', swiper);
		var foundElements = SwiperInstance.find('.swiper-slide');

		if (foundElements.length == 1) {
			SwiperInstance.addClass('swiper--single');
			SwiperInstance.find('.swiper-button').css('display', 'none');
		};
	}

	$window.on('resize', throttle(() => {
		swiperInstances.forEach(({ swiper, $container }) => {
			toggleMobileSwiper(swiper, $container);
		});
		publish('/window/resize');
	}, 250));


	function toggleMobileSwiper(swiper, $container) {
		if (window.innerWidth >= 1024) {
			swiper.destroy(false, true);
			$container.find('.js-swiper-control--mobile-only').hide();
		} else {
			swiper.init();
			$container.find('.js-swiper-control--mobile-only').show();
		}
	}

}


// Gallery Grid Lightbox
import { GalleryGrid } from 'Controls/control.gallery-grid';
const $galleryGrids = $('.js-gallery-grid');

if ($galleryGrids.length) {
	GalleryGrid.init($galleryGrids);
}

// Gallery Rotator Lightbox
import { GalleryRotator } from 'Controls/control.gallery-rotator';
const $galleryRotators = $('.js-gallery-rotator');

if ($galleryRotators.length) {
	GalleryRotator.init($galleryRotators);
}

// Google Maps
import { GoogleMap } from 'Controls/control.google-map';
GoogleMap.init();


// Expand and Collapse
if (document.querySelector('.js-expand-collapse')) {
	expandCollapse.init();
}

// Select Link
if (document.querySelector('.js-select-link')) {
	selectLink.init();
}

// Filters
import { Flyout } from 'Controls/control.flyout';

if (document.querySelector('.js-flyout')) {
	Flyout.init();
}

import { NewsFilters } from 'Controls/control.news-filters';
if (document.querySelector('.js-news-filter-toggler')) {
	NewsFilters.init();
}

// Modal
if (document.querySelector('.js-modal')) {
	import(/* webpackChunkName: "Modal" */ 'App/modal/modal').then(({ modal }) => {
		modal.init({
			onShow: function ($modal) {
				var $rotators = $modal.find('.js-rotator');
				var thisFlick;
				$rotators.each(function (i, el) {
					thisFlick = $(el).data('flickity-instance');

					if (thisFlick) {
						thisFlick.resize();
					}
				});
			}
		});
	});
}

// Sitewide Announcement
document.addEventListener('click', function (e) {
	if (e.target.classList.contains('js-remove-announcements')) {
		var announcement = e.target.closest('.js-announcements');

		// Store the dismissed announcement id in sessionStorage
		let dismissed = sessionStorage.getItem('dismissedAnnouncements');
		sessionStorage.setItem('dismissedAnnouncements', true);

		announcement.remove();
	}
});

document.addEventListener('DOMContentLoaded', function () {
	let dismissed = sessionStorage.getItem('dismissedAnnouncements');
	let announcement = document.querySelector('.js-announcements');
	if (!dismissed || dismissed === null) {
		announcement?.classList?.remove('is-hidden');
	}
});



// Scroll Appear
if (document.querySelector('.js-scroll-appear')) {
	import(/* webpackChunkName: "ScrollAppear" */ 'App/scroll-appear/scroll-appear').then(({ scrollAppear }) => {
		scrollAppear.init();
	});
}

// Umbraco Forms
const $umbracoForms = $('.js-umbraco-form');
if ($umbracoForms.length) {
	import(/* webpackChunkName: "UmbracoForms" */ 'App/form/form.umbraco').then(({ UmbracoForms }) => {
		UmbracoForms.init();
	});
}

// Video Player
if (document.querySelector('.js-video-player')) {
	import(/* webpackChunkName: "VideoPlayer" */ 'App/video/video.player').then(({ VideoPlayer }) => {
		VideoPlayer.init();
	});
}

// Video Gallery
if (document.querySelector('.js-video-gallery')) {
	import(/* webpackChunkName: "VideoGallery" */ 'App/video/gallery').then(({ videoGallery }) => {
		videoGallery.init();
	});
}

// Interactive Image
if (document.querySelector('.js-interactive-image')) {
	import(/* webpackChunkName: "InteractiveImage" */ 'Controls/control.interactive-image').then(({ InteractiveImage }) => {
		const $interactiveImages = $('.js-interactive-image');
		InteractiveImage.init($interactiveImages);
	});
}

// Webcam
if (document.querySelector('.js-webcams-list')) {
	import(/* webpackChunkName: "Webcams" */ 'Controls/control.webcams').then(({ Webcams }) => {
		const $webcamsRotators = $('.js-webcams-list');
		Webcams.init($webcamsRotators);
	});
}

// Tab Control
if (document.querySelector('.js-tab-control')) {

	document.addEventListener('DOMContentLoaded', function () {
		const tabButtons = document.querySelectorAll('.js-tab-control__button ');
		const tabPanels = document.querySelectorAll('.js-tab-control__panel');

		tabButtons.forEach(button => {
			button.addEventListener('click', function () {
				// Remove active class from all buttons
				tabButtons.forEach(btn => btn.classList.remove('active'));
				// Add active class to the clicked button
				this.classList.add('active');

				// Hide all panels
				tabPanels.forEach(panel => {
					panel.setAttribute('hidden', true);
					panel.classList.remove('always-open');
					panel.dispatchEvent(new CustomEvent('tabClosed'));
				});

				// Show the corresponding panel
				const targetPanelId = this.getAttribute('data-tab');
				const targetPanel = document.getElementById(targetPanelId);

				targetPanel.removeAttribute('hidden');
				targetPanel.classList.add('always-open');

				targetPanel.dispatchEvent(new CustomEvent('tabActivated'));
			});
		});
	});
}

// Car Rental

import { carRental } from 'App/car-rental/car-rental';
import { campervan } from 'App/campervan/campervan';

campervan.init();

document.addEventListener("DOMContentLoaded", function (event) {
	if (document.getElementById('VehicleSearchForm')) {
		carRental.init();
	}
});

window.addEventListener('resize', function () {
    $('body').removeClass('is-open');
});

window.addEventListener('message', function(event) {
    // Validate origin for security
    if (event.origin !== window.location.origin) {
        return;
    }

    // Handle motorhome/campervan form submission from iframe
    if (event?.data?.type === 'motorhomeSubmission' && event?.data?.formData) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            "event": "MotorhomeSubmission",
            "data": event.data.formData
        });
        console.log('Motorhome form submission received from iframe:', event.data.formData);
    }
});


if (document.getElementById('apr-widget')) {
	(function(w,d,s,o,f){
	  w[o]=w[o]||function(){(w[o].q=w[o].q||[]).push(arguments)};
	  var js=d.createElement(s), fjs=d.getElementsByTagName(s)[0];
	  js.src=f; js.async=true; fjs.parentNode.insertBefore(js,fjs);
	})(window,document,'script','gsc','https://cdn.goseetravel.com/cars-pw/widget.js');

	gsc('init', {
	  "target": "#apr-widget",
	  "host": "rentalcars.queenstownairport.co.nz",
	  "affiliate": "zqn",
	  "tagline": "Search car rentals at Queenstown Airport",
	  "language": "en",
	  "searchButton": {
		"text": "SEARCH CARS"
	  },
	  "pickupLocation": {
		"id": 238983,
		"text": "Queenstown Airport (ZQN), South Island, New Zealand"
	  },
	  "theme": {
		"--swr-button-bg": "#c789bb",
		"--swr-button-bg-hover": "#323231",
		"--swr-button-bg-active": "#323231",
		"--swr-button-text": "#FFFFFF",
		"--swr-button-font-weight": "400",
		"--swr-radius": "100px",
		"--swr-font-family": "neue-haas-unica, sans-serif"
	  }
	});

	// Detect when the widget has successfully rendered its content
	const aprWidgetTarget = document.getElementById('apr-widget');
	let aprWidgetLoaded = false;

	const reportAprWidgetLoaded = () => {
		if (aprWidgetLoaded) return;
		aprWidgetLoaded = true;
		console.log('apr-widget loaded successfully');
		aprWidgetObserver.disconnect();
		clearInterval(aprWidgetPollId);
	};

	const aprWidgetHasRendered = () =>
		aprWidgetTarget.childNodes.length > 0 || !!aprWidgetTarget.shadowRoot;

	// Some widgets render inside a Shadow DOM, which MutationObserver on the
	// light DOM host won't detect, so fall back to polling as well.
	const aprWidgetObserver = new MutationObserver(() => {
		if (aprWidgetHasRendered()) {
			reportAprWidgetLoaded();
		}
	});

	aprWidgetObserver.observe(aprWidgetTarget, { childList: true, subtree: true });

	const aprWidgetPollId = setInterval(() => {
		if (aprWidgetHasRendered()) {
			reportAprWidgetLoaded();
		}
	}, 250);

	// Stop polling after 30 seconds in case the widget never loads
	setTimeout(() => clearInterval(aprWidgetPollId), 30000);
}